import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { StockCountPageContainer } from 'app/modules/stock-count/stock-count-page-container/stock-count-page.container';
import { StockCountDetailComponent } from 'app/modules/stock-count/stock-count-detail/stock-count-detail.component';
import { StockCountLocationContainer } from './stock-count-create/stock-count-create.container';
import { GetStockCountGuard } from 'app/core/store/stock-count/stock-count-detail.resolve';
import { AuthenticatedGuard } from 'app/core/guards/authenticated.guard';
import { StockCountPrintComponent } from './stock-count-print/stock-count-print.component';
import { StockCountLocationsLoadGuard } from '../../core/guards/stock-count-locations-load.guard';

const routes: Routes = [
  {
    path: 'stock-count',
    component: StockCountPageContainer,
    canActivate: [StockCountLocationsLoadGuard, AuthenticatedGuard],
  },
  {
    path: 'stock-count/detail/:stockCountNumber',
    component: StockCountDetailComponent,
    canActivate: [GetStockCountGuard, AuthenticatedGuard],
  },
  {
    path: 'stock-count/new',
    component: StockCountLocationContainer,
    canActivate: [AuthenticatedGuard],
  },
  {
    path: 'stock-count/print',
    component: StockCountPrintComponent,
    canActivate: [AuthenticatedGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class StockCountRoutingModule {}
